import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RELEASE_NOTES, ReleaseNote } from './release-notes.data';

@Component({
    standalone: true,
    selector: 'app-release-notes',
    imports: [CommonModule],
    templateUrl: './release-notes.component.html',
    styleUrls: ['./release-notes.component.css']
})
export class ReleaseNotesComponent implements OnInit {
    /** Cleared by UserScopedState on every login, so the popup can auto-open once per login. */
    private static readonly autoShownKey = 'releaseNoteAutoShown';

    note: ReleaseNote;
    showCard = false;
    showDetail = false;
    hasUnseen = false;

    ngOnInit(): void {
        this.note = RELEASE_NOTES[0];
        if (!this.note) {
            return;
        }

        this.hasUnseen = localStorage.getItem(this.seenKey()) !== this.note.id;
        if (this.hasUnseen && !sessionStorage.getItem(ReleaseNotesComponent.autoShownKey)) {
            sessionStorage.setItem(ReleaseNotesComponent.autoShownKey, '1');
            setTimeout(() => (this.showCard = true), 1500);
        }
    }

    toggleCard(): void {
        if (this.showDetail) {
            this.close();
            return;
        }
        this.showCard = !this.showCard;
    }

    openDetail(): void {
        this.showCard = false;
        this.showDetail = true;
    }

    close(event?: Event): void {
        event?.stopPropagation();
        this.showCard = false;
        this.showDetail = false;
        this.hasUnseen = false;
        localStorage.setItem(this.seenKey(), this.note.id);
    }

    private seenKey(): string {
        return `releaseNoteSeen_${abp.session.tenantId ?? 'host'}_${abp.session.userId}`;
    }
}
